import { defineStore } from 'pinia'
export const useLanguageStore = defineStore('language', {
  state: () => ({
    language: 'En' // default language
  }),
  actions: {
    setLanguage(language: string) {
      this.language = language
    }
  }
})
